import { useAtomValue } from 'jotai';
import { hiddenWidgetsAtom } from 'stores/dashboard-store/dashboard-store';
import { WidgetType } from 'modules/dashboard/types/widgets/widget.enums';

export const useShouldHideInfo = (widgetType: WidgetType): boolean => {
  const hiddenWidgets = useAtomValue(hiddenWidgetsAtom);
  return hiddenWidgets.includes(widgetType);
};
